import { createApp } from 'vue'

import App from './presentation/App.vue'

// Import PrimeVue 4 theme
import 'primeicons/primeicons.css'
import '@/presentation/styles/main.css'

import { registerPlugins } from '@/presentation/plugins'

const app = createApp(App)

registerPlugins(app)

app.mount('#app')
